<template>
  <div class="p-3">
    <IconField class="w-full">
      <InputIcon class="pi pi-search" />
      <InputText
        ref="inputRef"
        :model-value="modelValue"
        type="text"
        class="w-full"
        role="searchbox"
        autocomplete="off"
        :placeholder="placeholder"
        :aria-owns="ariaOwns"
        :aria-activedescendant="ariaActiveDescendant"
        @keydown="emit('keydown', $event)"
        @blur="emit('blur', $event)"
        @update:model-value="emit('update:modelValue', $event ?? '')"
      />
      <InputIcon
        v-if="showClearButton"
        class="pi pi-times cursor-pointer"
        role="button"
        tabindex="-1"
        aria-label="Clear search"
        @mousedown.prevent
        @click="onClearClick"
      />
    </IconField>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import InputText from 'primevue/inputtext'
import IconField from 'primevue/iconfield'
import InputIcon from 'primevue/inputicon'
import { shouldShowGpxSelectFilterClear } from './gpx-select-filter-input'

const props = defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  showClear: { type: Boolean, default: true },
  ariaOwns: { type: String, default: undefined },
  ariaActiveDescendant: { type: String, default: undefined },
})

const emit = defineEmits(['update:modelValue', 'keydown', 'blur'])

const inputRef = ref(null)

const showClearButton = computed(() =>
  shouldShowGpxSelectFilterClear(props.modelValue, props.showClear),
)

function focus() {
  const el = inputRef.value?.$el ?? inputRef.value
  el?.focus?.()
}

function onClearClick() {
  emit('update:modelValue', '')
  focus()
}

defineExpose({ focus })
</script>
